angular.module('PinMeTo.directives').directive('contenteditable', [
	'$timeout',
	function ($timeout) {
		'use strict';

		return {
			restrict: 'A',
			require: '?ngModel',
			link: function (scope, element, attrs, ngModel) {
				if (!ngModel) {
					return;
				}

				var opts = {};
				angular.forEach(
					['stripBr', 'noLineBreaks', 'selectNonEditable', 'moveCaretToEndOnChange', 'stripTags'],
					function (opt) {
						var o = attrs[opt];
						opts[opt] = o && o !== 'false';
					}
				);

				element.bind('input', function () {
					scope.$apply(function () {
						var html;
						html = element.html();
						if (opts.stripTags) {
							html = html
								.replace(/<div>/g, '')
								.replace(/<br>/g, '\n')
								.replace(/<\/div>/g, '\n');
							html = html.replace(/<\S[^><]*>/g, '');
							html = html.replace(/&nbsp;/g, ' ');
						}
						ngModel.$setViewValue(html);
					});
				});

				// model -> view
				var oldRender = ngModel.$render;
				ngModel.$render = function () {
					var el, el2, range, sel;
					if (!!oldRender) {
						oldRender();
					}
					var html = ngModel.$viewValue || '';
					if (opts.stripTags) {
						html = html
							.replace(/<div>/g, '')
							.replace(/<br>/g, '\n')
							.replace(/<\/div>/g, '\n');
						html = html.replace(/<\S[^><]*>/g, '');
						html = html.replace(/&nbsp;/g, ' ');
					}

					element.html(html);
					if (opts.moveCaretToEndOnChange) {
						el = element[0];
						range = document.createRange();
						sel = window.getSelection();
						if (el.childNodes.length > 0) {
							el2 = el.childNodes[el.childNodes.length - 1];
							range.setStartAfter(el2);
						} else {
							range.setStartAfter(el);
						}
						range.collapse(true);
						sel.removeAllRanges();
						sel.addRange(range);
					}
				};
				if (opts.selectNonEditable) {
					element.bind('click', function (e) {
						var range, sel, target;
						target = e.toElement;
						if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
							range = document.createRange();
							sel = window.getSelection();
							range.setStartBefore(target);
							range.setEndAfter(target);
							sel.removeAllRanges();
							sel.addRange(range);
						}
					});
				}
			}
		};
	}
]);
